import Logo from 'assets/logo/logo-doku-coach-small.svg';
import IndicatorsAside from 'components/Layout/components/IndicatorsAside';
import ListsAside from 'components/Layout/components/ListsAside';
import LoginInfo from 'components/Layout/components/LoginInfo';
import MenuItems from 'constants/main-menu';
import React from 'react';
import { Image } from 'react-bootstrap';
import styled from 'styled-components';
import { useContextLayout } from '../../context';
import BaseDataAside from '../BaseDataAside';
import ConfigurationAside from '../ConfigurationAside';
import DashboardAside from '../DashboardAside';
import InvoicingAside from '../InvoicingAside';
import { LogoutButton } from '../LogoutButton';
import Menu from './Menu';

type Prop = {
  isHiddenAside?: boolean;
};

const AsideContainer = styled.div`
  height: 100%;
  background-color: ${(props) => props.theme.colors.white};
`;

const MainMenu = styled.div`
  && {
    border-right: 1px solid ${(props) => props.theme.colors.solitude};
  }
`;

const Img = styled(Image)`
  padding-top: 10px;
`;

const MenuFooter = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 14px;
`;

const Aside = ({ isHiddenAside }: Prop) => {
  const { menuActive, refMenu, asideSelected } = useContextLayout();
  return (
    <AsideContainer
      id="kt_aside"
      className={`aside aside-left d-flex aside-fixed ${menuActive}`}
      ref={refMenu}
    >
      <MainMenu className="aside-primary d-flex flex-column align-items-center flex-row-auto">
        <Img src={Logo} />
        <div className="aside-nav d-flex flex-column align-items-center flex-column-fluid py-5 scroll scroll-pull">
          <Menu />
        </div>
        <MenuFooter>
          <LoginInfo />
          <LogoutButton />
        </MenuFooter>
      </MainMenu>
      {!isHiddenAside && asideSelected === MenuItems.DASHBOARD && <DashboardAside />}
      {!isHiddenAside && asideSelected === MenuItems.BASE_DATA && <BaseDataAside />}
      {!isHiddenAside && asideSelected === MenuItems.CONFIGURATION && <ConfigurationAside />}
      {!isHiddenAside && asideSelected === MenuItems.ANALYTICS && <ListsAside />}
      {!isHiddenAside && asideSelected === MenuItems.INDICATORS && <IndicatorsAside />}
      {!isHiddenAside && asideSelected === MenuItems.INVOICING && <InvoicingAside />}
    </AsideContainer>
  );
};

export default Aside;
